<template>
<div class="grid" >
<div class="col-12">
<div class="flex align-items-center justify-content-end" v-if="!is_supplier && !is_planner">
<div class="hide_on_mobile"><Button type="button" :class="'p-button-primary p-button-outlined p-button-sm mt-2'" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-primary p-button-outlined p-button-sm mt-2'" icon="pi pi-plus" @click="addNew" /></div>
</div>
</div>

<div class="col-12" v-if="show">
<div class="grid">
<div class="col-12  md:col-6">






<div class="p-float-label mb-5 mt-0">
<InputText  type="text" v-model="newitem.certification_body" class="w-full p-inputtext-sm animate_class"  />
<label for="dd-city">{{$store.state.languages.lang_phrases.sertifika_tedarikcisi}}</label>
</div>

<span class="p-float-label mb-5 mt-0" >
<Calendar v-model="newitem.valid_through"   :id="'valid_through'"  :showButtonBar="true" class="w-full p-inputtext-sm" :touchUI="true"  autocomplete="off"/>
 <label :for="'valid_through'"  >{{$store.state.languages.lang_phrases.gecerlilik_suresi}}</label>
</span>


</div>



<div class="col-12  md:col-6">

<FileUpload name="cover_image[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="newitem.files" :multiple="false" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="certificate_uploader" >
  <template #empty>
      <div class="certificate_uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>Dosyaları buraya sürükleyip bırakın</p>
    </div>
  </template>
</FileUpload>

</div>

<div class="col-12">
<div class="flex align-items-center justify-content-end mt-3">

<Button :label="$store.state.languages.lang_phrases.iptal" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  @click="canceladdNew"></Button>

 <Button :label="$store.state.languages.lang_phrases.yeni_ekle" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submitNewDocument" ></Button>
</div>


</div> 
</div>   

</div>

</div>
</template>

<script>
import moment from "moment";
export default {

  name: '"RequiredDocumentUpload"',
  props:["exemptioncertificate","certificatetypes","flowsupplier"],
  data () {
    return {
    	show:false,    	
        submitting:false,
        newitem:{
            files:[],
            valid_through:null,
            certification_body:"",
            certificatetype_id:null,
        },
    }
  },
  computed:{
    is_supplier()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("supplier"))
        {
            return true
        }
        return false
    },
    is_planner()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("planner"))
        {
            if(roles.includes("admin"))
            {
                return false
            }
            else
            {
                let viewingmode = this.$store.state.evaluation.viewingmode
                if(viewingmode=="submitting")
                {
                    return false
                }
                return true
                
                
            }
            
        }
        return false
    },
  },
  methods:{
  	onFilesAdded(event)
    {
        this.newitem.files = []
        for(let file of event.files)
        {
            this.newitem.files.push(file)
        }
    },
  	display(data)
  	{
  		this.show = data
  	},
  	addNew()
  	{
  		this.display(true)
  	},
  	canceladdNew()
  	{
  		this.display(false)
  	},
  	submitNewDocument()
    {
        if(this.newitem.certification_body=="")
        {
            this.showMessage("error","Lütfen sertifika tedarikçisi ekleyin")
            return 
        }
        if(!this.newitem.valid_through)
        {
            this.showMessage("error","Lütfen geçerlilik süresini belirleyin")
            return 
        }

        if(!this.newitem.files.length)
        {
            this.showMessage("error","Lütfen belge yükleyin")
            return 
        }

        let formdata = new FormData()

        for( var i = 0; i < this.newitem.files.length; i++ )
        {
          let file =  this.newitem.files[i];
          formdata.append('files[' + i + ']', file);
        }
        console.log(moment(this.newitem.valid_through).format("YYYY-MM-DD"))
        //return 
        formdata.append("certification_body",this.newitem.certification_body)
        formdata.append("valid_through",moment(this.newitem.valid_through).format("YYYY-MM-DD"))
        formdata.append("certificatetype_id",this.exemptioncertificate.certificatetype.id)
        formdata.append("flowsupplier_id",this.flowsupplier.id)
        this.generalSubmission(formdata,"audit/submitsupplier_certificate",this.afterSubmit)
    },
    afterSubmit(response)
    {
    	this.newitem = {
            files:[],
            valid_through:null,
            certification_body:"",
        }
    	this.display(false)
    	this.$emit("newFileUploaded")
    },
  }
}
</script>

<style lang="css" scoped>
    .certificate_uploader_empty{
    display: flex;
      width: 100%;
      height: 75px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px dashed rgb(180, 180, 180);
}
</style>